import logger from '../common/safe-log';

const GAVirtualPathMap = {
  'GalleryChanged': '/creative/gallery-changed/',
  'ShowFAQs': '/faq/show/',
  'OpenFAQ': '/faq/open/',
  'CloseFAQ': '/faq/close/',
  'Testimonials': '/testimonials/',

  'Yes To Inline Upsell': '/promotions-upsell/upsell-inline-click-yes/',
  'No To Inline Upsell': '/promotions-upsell/upsell-inline-click-no/',
  'Remove Inline Upsell': '/promotions-upsell/remove-upsell-inline-click/',
  'UpsellReject': '/promotions-upsell/upsell-reject/',
  'UpsellAccept': '/promotions-upsell/upsell-accept/',
  'No To Pop Sale': '/promotions-upsell/upsell-popup-click-no/',
  'Change Color Selection': '/promotions-upsell/color-selector-click/',

  'Page Start': '/page-view/start/',
  'Landing Page Start': '/landing-page/start/',
  'Presell Page Start': '/presell-page/start/',
  'Splash Page Start': '/splash-page/start/',

  'Page View': '/page-view/default/',
  'Landing Page': '/landing-page/default/',
  'Presell Page': '/presell-page/default/',
  'Splash Page': '/splash-page/default/',
  'Select Bundle': '/promotions/bundle-click',
  'Click PayPal': '/checkout/go-to-paypal/',
  'Shipping Info': '/checkout/shipping-info',
  'Initiate Checkout': '/checkout/initiate-checkout/',

  'View Shipping Page': '/checkout/view-shipping-page/',
  'View Credit Card Page': '/checkout/view-credit-card-page/',
  'Submit Order': '/checkout/submit-order/',

  'Incorrect State Input': '/errors/incorrect-state-input/',
  'Retrying Shipping Server': '/errors/retry-shipping-server/',
  'Retrying Server Connection': '/errors/retry-server-connection/',
  'Retrying Shipping Connection': '/errors/retry-shipping-connection/',
  'Credit Card Failed': '/errors/credit-card-failed/',
  'Error Updating Cart': '/errors/cart-update-failed/',
  'Internet or Shopify Down': '/errors/shopify-down/',
  'Error Processing Order': '/errors/order-processing-failed/',
  'Success Updating Cart': '/checkout/update-cart-success/',
};

const GAEventMapping = {
  'Page Start': {
    isNonInteraction: true,
    gaEventCategory: 'Giddyup OTM'
  },
  'Page View': {
    isNonInteraction: true,
    gaEventCategory: 'Giddyup OTM'
  },
  'Landing Page Start': {
    isNonInteraction: true,
    gaEventCategory: 'Giddyup OTM'
  },
  'Landing Page': {
    fireGoogleAnalyticsEvent: true,
    gaEventName: 'Landing Page',
    gaQspNameOverride: 'galp',
    isNonInteraction: true,
    gaEventCategory: 'Giddyup OTM'
  },
  'Presell Page Start': {
    isNonInteraction: true,
    gaEventCategory: 'Giddyup OTM'
  },
  'Presell Page': {
    fireGoogleAnalyticsEvent: true,
    gaQspNameOverride: 'gapp',
    isNonInteraction: true,
    gaEventCategory: 'Giddyup OTM'
  },
  'Splash Page Start': {
    isNonInteraction: true,
    gaEventCategory: 'Giddyup OTM'
  },
  'Splash Page': {
    fireGoogleAnalyticsEvent: true,
    gaQspNameOverride: 'gasp',
    isNonInteraction: true,
    gaEventCategory: 'Giddyup OTM'
  },
  'Select Bundle': {
    fireGoogleAnalyticsEvent: true,
    gaQspNameOverride: 'gaatc',
    gaEventCategory: 'Giddyup OTM'
  },
  'Initiate Checkout': {
    fireGoogleAnalyticsEvent: true,
    gaQspNameOverride: 'gaic',
    gaEventCategory: 'Giddyup OTM'
  },
  'Shipping Info': {
    fireGoogleAnalyticsEvent: true,
    gaQspNameOverride: 'gasi',
    gaEventCategory: 'Giddyup OTM'
  },
  'Order Conversion': {
    fireGoogleAnalyticsEvent: true,
    gaQspNameOverride: 'gaoc',
    gaEventCategory: 'Giddyup OTM',
    gaEcomEventName: 'purchase',
    gawEventName: 'conversion'
  },
};

const module = 'GtagUATracker';
const GtagUATracker = {
  load: (pixelId, async = true) => {
    try {
      /* eslint-disable */

            (function (d) {
                var file = 'https://www.googletagmanager.com/gtag/js?id=' + pixelId;
                var ref = d.getElementsByTagName('script')[0];
                var js = d.createElement('script');
                js.src = file;
                js.async = async;
                ref.parentNode.insertBefore(js, ref);
            }(document));
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () {
                window.dataLayer.push(arguments);
            }
            window.gtag('js', new Date());
            window.gtag('config', pixelId, {
                'site_speed_sample_rate': 100,
                'linker': {
                    'accept_incoming': true
                }
            });

            /* eslint-enable */
    } catch (e) {
      logger.error('load failed', e, { module });
    }
  },
  initAdditional: (pixelId) => {
    try {
      if (!window?.gtag) {
        GtagUATracker.load(pixelId);
      } else {
        window.gtag('js', new Date());
        window.gtag('config', pixelId, {
          'linker': {
            'accept_incoming': true
          }
        });
      }
    } catch (e) {
      logger.error('initAdditional failed', e, { module });
    }
  },
  trackEvent: (eventProperties) => {
    try {
      if (window.gtag) {
        const eventName = eventProperties.eventName;
        const eventConfig = GAEventMapping[eventName];

        let gaEventName = eventConfig?.gaEventName ?? eventName;
        let gaProperties = GtagUATracker.buildGaEventProperties(eventProperties, eventConfig);

        // track default internal
        if (window.ga_account_id) {
          const eventTrack = GtagUATracker.track(gaEventName, gaProperties, window.ga_account_id);
          const virtualPageView = GtagUATracker.sendVirtualPageView(eventName);
          let ecommerceEvent;
          if (eventConfig?.gaEcomEventName) {
            ecommerceEvent = GtagUATracker.trackEcommerceEvent(eventConfig?.gaEnhancedEcomEventName, window.ga_account_id);
          }
          return { eventTrack, virtualPageView, ecommerceEvent };
        }

        // if (window?.gu_ap?.ga) {
        //     gaEventName = window?.gu_ap?.[eventConfig?.gaQspNameOverride] ?? gaEventName;
        //     GtagUATracker.gaTrackEvent(window.gu_ap.ga, gaEventName, gaProperties);
        // }
        // if (window?.gu_ap?.gaw && eventProperties.eventName == "Order Conversion") {
        //     gaEventName = window?.gu_ap?.[eventConfig?.gaQspNameOverride] ?? gaEventName;
        // }
        //gtag('event', eventProperties.eventName, gaProperties);
      }
    } catch (e) {
      logger.error('trackEvent failed', e, { module });
    }
  },
  trackEcommerceEvent: (ecomEventName, send_to) => {
    try {
      const eventData = { send_to, id: window.t, transaction_id: window.t, value: window?.gu_payments?.order?.order?.total_price, currency: 'USD' };

      if (ecomEventName == 'purchase') {
        GtagUATracker.track(ecomEventName, eventData);
      }

      return { gaEvent: ecomEventName, gaArgs: eventData };
    } catch (e) {
      logger.error('trackEcommerceEvent failed', e, { module });
    }
  },
  buildGaEventProperties: (eventProperties, eventConfig) => {
    try {
      var gaProperties = {
        event_category: eventConfig?.gaEventCategory ?? 'Giddyup OTM',
        non_interaction: eventConfig?.isNonInteraction ?? false,
        eventLabel: eventProperties?.propertyName ?? '',
        value: eventProperties?.propertyValue ?? ''
      };
      if (eventProperties.eventName == 'Order Conversion') {
        gaProperties.transaction_id = window.t;
      }
      return gaProperties;
    } catch (e) {
      logger.error('buildGaEventProperties failed', e, { module });
      return {};
    }
  },
  track: (gaEvent, gaArgs, send_to = null) => {
    try {
      if (send_to) {
        gaArgs.send_to = send_to;
      }
      //console.log('ga track event:' + gaEvent + ':' + JSON.stringify(gaArgs));
      window.gtag('event', gaEvent, gaArgs);

      return { gaEvent, gaArgs };
    } catch (e) {
      logger.error('track failed', e, { module });
    }
  },
  sendVirtualPageView: (eventName, send_to = null) => {
    try {
      if (GAVirtualPathMap?.[eventName]) {
        let gaArgs = {
          page_path: GAVirtualPathMap[eventName],
          page_title: 'VPV - ' + eventName,
          non_interaction: true
        }
        if (send_to) {
          gaArgs.send_to = send_to;
        }
        window.gtag('event', 'page_view', gaArgs);

        return { gaEvent: 'page_event', gaArgs };
      }
    } catch (e) {
      logger.error('sendVirtualPageView failed', e, { module });
    }
  },
};
export default GtagUATracker;